import { render } from "./RoleOnBehalfOfPicker.vue?vue&type=template&id=dd62c67e&ts=true"
import script from "./RoleOnBehalfOfPicker.vue?vue&type=script&lang=ts"
export * from "./RoleOnBehalfOfPicker.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__